// MAIN COLORS
export const tesaBlue = "rgb(0, 159, 223)";
export const tesaRed = "rgb(227, 0, 15)";
/**
 * #212121
 * @type {string}
 */
export const tesaDarkGrey = "rgb(51, 51, 51)";
export const tesaBlueProfessional = "rgb(15, 55, 127)";
export const tesaPurple = "#56657F";

// ADDITIONAL COLORS - GREY
/**
 * #757575
 * @type {string}
 */
export const tesaGrey1 = "rgb(117, 117, 117)";
export const tesaGreyDisabled = "rgba(0, 0, 0, 0.38)";
export const tesaGrey2 = "rgb(177, 178, 179)";
export const tesaGrey3 = "rgb(197, 198, 198)";
export const tesaGrey4 = "rgb(217, 218, 218)";
/*
 * #ECECED
 * @type {string}
 */
export const tesaGrey5 = "rgb(236, 236, 237)";
/*
 * #F5F5F5
 * @type {string}
 */
export const tesaGrey6 = "rgb(245, 245, 245)";

// ADDITIONAL COLORS - BLUE
export const tesaBlue1 = "rgb(99, 136, 152)";
export const tesaBlue2 = "rgb(161, 217, 248)";
export const tesaBlue3 = "rgb(205, 234, 252)";
export const tesaBlue4 = "rgb(223, 242, 254)";
export const tesaModalBlue = "rgba(0, 159, 223, 0.25)";

// FUNCTIONAL COLORS
export const tesaWhite = "rgb(255, 255, 255)";
export const tesaWhiteHighlight = "rgba(255, 255, 255, 0.2)";
export const tesaWhiteHighlight2 = "rgba(255, 255, 255, 0.4)";
export const tesaDark = "rgb(33, 33, 33)";
export const tesaDarkRedError = "rgb(191, 8, 20)";
export const tesaGreenPositive = "rgb(100, 163, 60)";
export const tesaYellowPending = "rgb(252, 215, 52)";
export const tesaAccent = "rgb(223, 242, 253)";

// CHIP COLORS
export const tesaChipGreen = "rgb(59, 208, 92)";
export const tesaChipOrange = "rgb(255, 152, 0)";
export const tesaChipYellow = "rgb(255, 235, 59)";
export const tesaChipLightblue = "rgb(223, 242, 253)";
export const tesaChipBlue = "rgb(0, 159, 223)";
export const tesaChipDarkblue = "rgb(15, 55, 127)";
export const tesaChipPurple = "rgb(156, 39, 176)";
export const tesaChipBlueGrey = tesaBlue1;
export const tesaChipTurquoise = "rgb(3, 182, 165)";
export const tesaChipGrey = tesaGrey4;
export const tesaChipRed = tesaRed;
